import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn';
import { controlInvalidClass, controlSurfaceClass } from './controlStyles';

export type InputProps = {
  className?: string;
  /**
   * Validation-invalid chrome (danger border) + `aria-invalid`.
   * Pair with `Field` `error` / `FieldMessage` for the message slot.
   */
  invalid?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'aria-invalid'>;

/** Text field control — ref-forwarding for react-hook-form `register`. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = 'text', invalid = false, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      aria-invalid={invalid || undefined}
      className={cn(
        controlSurfaceClass,
        'h-8 px-2.5',
        invalid && controlInvalidClass,
        className,
      )}
      {...props}
    />
  );
});
